interface IconProps {
  fill?: string;
}

export const FacebookIcon: React.FC<IconProps> = ({ fill }) => {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27 13.5825C27 6.08114 20.9558 0 13.5 0C6.0442 0 0 6.08114 0 13.5825C0 20.3619 4.93678 25.9811 11.3906 27V17.5087H7.96289V13.5825H11.3906V10.5901C11.3906 7.18599 13.4061 5.30567 16.4898 5.30567C17.9668 5.30567 19.5117 5.57095 19.5117 5.57095V8.91352H17.8095C16.1324 8.91352 15.6094 9.96054 15.6094 11.0347V13.5825H19.3535L18.755 17.5087H15.6094V27C22.0632 25.9811 27 20.362 27 13.5825Z"
        fill={fill ? fill : "black"}
      />
    </svg>
  );
};
export const GoogleIcon = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.6226 10.8783H22.75V10.8333H13V15.1667H19.1224C18.2292 17.6892 15.8291 19.5 13 19.5C9.41033 19.5 6.49996 16.5896 6.49996 13C6.49996 9.41038 9.41033 6.50001 13 6.50001C14.6569 6.50001 16.1644 7.12509 17.3122 8.14613L20.3764 5.08192C18.4415 3.27871 15.8535 2.16667 13 2.16667C7.01725 2.16667 2.16663 7.0173 2.16663 13C2.16663 18.9827 7.01725 23.8333 13 23.8333C18.9827 23.8333 23.8333 18.9827 23.8333 13C23.8333 12.2736 23.7585 11.5646 23.6226 10.8783Z"
        fill="#FFC107"
      />
      <path
        d="M3.41577 7.95763L6.97506 10.5679C7.93815 8.1835 10.2706 6.5 13 6.5C14.657 6.5 16.1644 7.12509 17.3122 8.14613L20.3764 5.08192C18.4416 3.27871 15.8535 2.16667 13 2.16667C8.83894 2.16667 5.23035 4.51588 3.41577 7.95763Z"
        fill="#FF3D00"
      />
      <path
        d="M13 23.8333C15.7982 23.8333 18.3408 22.7625 20.2632 21.021L16.9103 18.1838C15.7861 19.0387 14.4123 19.5011 13 19.5C10.1822 19.5 7.78967 17.7033 6.88834 15.1959L3.35559 17.9178C5.14851 21.4262 8.78959 23.8333 13 23.8333Z"
        fill="#4CAF50"
      />
      <path
        d="M23.6226 10.8783H22.75V10.8333H13V15.1667H19.1225C18.6952 16.3672 17.9256 17.4163 16.9087 18.1843L16.9103 18.1832L20.2632 21.0205C20.026 21.236 23.8333 18.4167 23.8333 13C23.8333 12.2736 23.7586 11.5646 23.6226 10.8783Z"
        fill="#1976D2"
      />
    </svg>
  );
};

export const EmailIcon = () => {
  return (
    <svg
      width="26"
      height="24"
      viewBox="0 0 26 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.825 0H6.175C4.53729 0 2.96665 0.649226 1.80862 1.80486C0.650578 2.96049 0 4.52785 0 6.16216V17.8378C0 18.6471 0.159721 19.4484 0.470044 20.196C0.780367 20.9436 1.23521 21.6229 1.80862 22.1951C2.96665 23.3508 4.53729 24 6.175 24H19.825C21.4617 23.9966 23.0303 23.3462 24.1876 22.1914C25.3449 21.0365 25.9966 19.4711 26 17.8378V6.16216C25.9966 4.52891 25.3449 2.96353 24.1876 1.80864C23.0303 0.653754 21.4617 0.00342762 19.825 0ZM15.08 10.7935C14.4404 11.1575 13.7168 11.349 12.9805 11.349C12.2442 11.349 11.5206 11.1575 10.881 10.7935L1.976 5.69513C2.09115 4.66417 2.58311 3.71176 3.35779 3.02006C4.13247 2.32837 5.13549 1.94595 6.175 1.94595H19.825C20.8637 1.94879 21.8652 2.33219 22.6393 3.02335C23.4133 3.71451 23.9061 4.66529 24.024 5.69513L15.08 10.7935Z"
        fill="black"
      />
    </svg>
  );
};

export const MenuIcon = () => {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 7.85587C8.70163 7.85587 8.41548 7.97439 8.20451 8.18537C7.99353 8.39635 7.875 8.6825 7.875 8.98087C7.875 9.27923 7.99353 9.56538 8.20451 9.77636C8.41548 9.98734 8.70163 10.1059 9 10.1059H18C18.2984 10.1059 18.5845 9.98734 18.7955 9.77636C19.0065 9.56538 19.125 9.27923 19.125 8.98087C19.125 8.6825 19.0065 8.39635 18.7955 8.18537C18.5845 7.97439 18.2984 7.85587 18 7.85587H9ZM7.875 13.5C7.875 13.2016 7.99353 12.9155 8.20451 12.7045C8.41548 12.4935 8.70163 12.375 9 12.375H18C18.2984 12.375 18.5845 12.4935 18.7955 12.7045C19.0065 12.9155 19.125 13.2016 19.125 13.5C19.125 13.7984 19.0065 14.0845 18.7955 14.2955C18.5845 14.5065 18.2984 14.625 18 14.625H9C8.70163 14.625 8.41548 14.5065 8.20451 14.2955C7.99353 14.0845 7.875 13.7984 7.875 13.5ZM9 16.8941C8.70163 16.8941 8.41548 17.0126 8.20451 17.2236C7.99353 17.4346 7.875 17.7207 7.875 18.0191C7.875 18.3175 7.99353 18.6036 8.20451 18.8146C8.41548 19.0256 8.70163 19.1441 9 19.1441H18C18.2984 19.1441 18.5845 19.0256 18.7955 18.8146C19.0065 18.6036 19.125 18.3175 19.125 18.0191C19.125 17.7207 19.0065 17.4346 18.7955 17.2236C18.5845 17.0126 18.2984 16.8941 18 16.8941H9Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.75 13.5C24.75 19.7134 19.7134 24.75 13.5 24.75C7.28663 24.75 2.25 19.7134 2.25 13.5C2.25 7.28663 7.28663 2.25 13.5 2.25C19.7134 2.25 24.75 7.28663 24.75 13.5ZM22.5 13.5C22.5 15.8869 21.5518 18.1761 19.864 19.864C18.1761 21.5518 15.8869 22.5 13.5 22.5C11.1131 22.5 8.82387 21.5518 7.13604 19.864C5.44821 18.1761 4.5 15.8869 4.5 13.5C4.5 11.1131 5.44821 8.82387 7.13604 7.13604C8.82387 5.44821 11.1131 4.5 13.5 4.5C15.8869 4.5 18.1761 5.44821 19.864 7.13604C21.5518 8.82387 22.5 11.1131 22.5 13.5Z"
        fill="black"
      />
    </svg>
  );
};

export const EyeOpened = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.10588 12C4.07176 7.77803 8.39401 5 12 5C15.606 5 19.9282 7.77803 21.8941 12C19.9282 16.2219 15.606 19 12 19C8.39401 19 4.07176 16.2219 2.10588 12ZM12 17C10.4882 17 8.67647 16.1055 7.10588 14.7071C7.10588 14.7071 4.94118 12 7.10588 9.29289C8.67647 7.89448 10.4882 7 12 7C13.5118 7 15.3235 7.89448 16.8941 9.29289C16.8941 9.29289 19.0588 12 16.8941 14.7071C15.3235 16.1055 13.5118 17 12 17ZM12 9.5C10.6193 9.5 9.5 10.6193 9.5 12C9.5 13.3807 10.6193 14.5 12 14.5C13.3807 14.5 14.5 13.3807 14.5 12C14.5 10.6193 13.3807 9.5 12 9.5Z"
        fill="#000000"
      />
    </svg>
  );
};
